function objectPage (content) {
  let page = {
    id: content.sys.id,
    name: content.fields.titre,
    redirectId: content.fields.redirectId,
    content: content.fields.content,
    destinations: content.fields.destinations,
    abstract: content.fields.abstract,
    contents: [],
    tips: []
  }
  return page
}
function objectRubric (item) {
  let rubric = {
    id: item.sys.id,
    redirectId: item.fields.redirectId,
    revision: item.sys.revision,
    name: item.fields.title,
    destinations: item.fields.destinations,
    abstract: item.fields.abstract,
    pages: []
  }
  console.log(item.fields)
  if (item.fields.media) {
    if (item.fields.media.length > 0) {
      rubric.media = item.fields.media[0].fields.file.url
    }
  }
  return rubric
}
export { objectRubric, objectPage }
